import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterContainer, FilterButtons, FilterButton, Title } from './styled';
import { PROJECTS_GRID_FILTERS } from '../../helpers';
import { ProjectsGridFilterBarProps } from '../../types';

export const ProjectsGridFilterBar: React.FC<ProjectsGridFilterBarProps> = ({
  filter,
  setFilter
}) => {
  const { t } = useTranslation();

  return (
    <FilterContainer>
      <Title>{t('pasha.title')}</Title>
      <FilterButtons>
        {PROJECTS_GRID_FILTERS.map(f => (
          <FilterButton
            key={f.value}
            active={filter === f.value}
            onClick={() => setFilter(f.value)}
            data-cy={`pasha-projects-${f.value}`}
            data-stat={`${f.value === 'ALL' ? 'all-sections' : f.value.toLocaleLowerCase()}-btn`}
          >
            {t(f.labelKey)}
          </FilterButton>
        ))}
      </FilterButtons>
    </FilterContainer>
  );
};
